/* eslint-disable react/prop-types */
import classes from "./software-mes.module.scss";
import Flex from "@/components-library/layout/flex";
import ComposedViewHeader from "@/composed-views/composed-view-header";
import ComposedViewOne from "@/composed-views/composed-view-one";
import ComposedViewFive from "@/composed-views/composed-view-five";
import ComposedViewEight from "@/composed-views/composed-view-eight";
import ComposedViewNine from "@/composed-views/composed-view-nine";
import ComposedViewSix from "@/composed-views/composed-view-six";
import Label from "@/components-library/widgets/label";
import GridList from "@/components-library/widgets/grid-list";
import CardViewModule from "@/composed-views/card-view-module";
import { SERVICES } from "@/static-texts/services";
import CardViewService from "@/composed-views/card-view-service";
import ComposedViewInfiniteCarousel from "@/composed-views/composed-view-infinite-carousel";

function SoftwareMes({ content }) {
  var item = <CardViewModule />;

  return (
    <Flex
      align="flex-start"
      className={classes.softwareMES}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader
        header={content.header.header}
        title={content.header.title}
        subTitle={content.header.subTitle}
      />

      <ComposedViewOne
        header={content.manufacturing.header}
        title={content.manufacturing.title}
        subTitle={content.manufacturing.subTitle}
        content={content.manufacturing.content}
        image={content.manufacturing.image}
        button={content.manufacturing.button}
      />

      <ComposedViewOne
        header={content.informations.header}
        title={content.informations.title}
        content={content.informations.content}
        image={content.informations.image}
        reverse={true}
        className={classes.informations}
      />
      <ComposedViewEight
        title={content.steps.title}
        stepOne={content.steps.stepOne}
        stepTwo={content.steps.stepTwo}
        stepThree={content.steps.stepThree}
        stepFour={content.steps.stepFour}
        stepFive={content.steps.stepFive}
        stepSix={content.steps.stepSix}
        stepSeven={content.steps.stepSeven}
      />
      <ComposedViewNine
        title={content.benefits.title}
        steps={content.benefits.steps}
        className={classes.benefits}
      />

      <ComposedViewFive
        title={content.contactUs.title}
        button={content.contactUs.button}
        className={classes.contactUs}
      />

      <ComposedViewOne
        header={content.fdc.header}
        title={content.fdc.title}
        content={content.fdc.content}
        image={content.fdc.image}
      />

      <ComposedViewSix
        title={content.concess.title}
        columnOne={content.concess.columnOne}
        columnTwo={content.concess.columnTwo}
        className={classes.concess}
      />

      <Flex
        align="flex-start"
        direction="column"
        justify="flex-start"
        className={classes.modules}
      >
        <Label
          weight="bold"
          tag="h4"
          color="primary"
          align="start"
          className={classes.title}
        >
          {content.modules.title}
        </Label>
        <Label
          align="start"
          size="md"
          color="secondary"
          className={classes.content}
        >
          {content.modules.content}
        </Label>

        <GridList
          columns={2}
          items={content.modules.list}
          itemComponent={item}
        />
      </Flex>

      <ComposedViewInfiniteCarousel
        title={content.services.title}
        subTitle={content.services.subTitle}
        items={Object.keys(SERVICES).map((key) => SERVICES[key])}
        itemType={<CardViewService size={"md"} />}
      />
    </Flex>
  );
}

export default SoftwareMes;
